import { get } from 'lodash';

export const selectTypeahead  = state => get(state, ['typeahead'], {});
export const selectTypeaheadResults = state => get(selectTypeahead(state), ['results'], []);
export const selectTypeaheadValue = state => get(selectTypeahead(state), ['value'], '');
